import Component from '../core/Component'
import { query } from '../utils/dom'

export default class ProductDetailDocuments extends Component {
    constructor(element, options = {}) {
        super(
            element,
            (options = {
                maxVisibleCount: 1,
                ...options,
            })
        )

        this.ref = {
            items: [],
        }

        this.isCompact = true
    }

    prepare() {
        this.element.addEventListener('change', this.handleChange)
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = (event) => {
        const element = event.target
        if (element.closest('[data-show-more-documents]')) {
            event.preventDefault()
            this.showMoreDocuments()
        }
    }

    handleChange = (event) => {
        const element = event.target
        const selectDocumentYearEl = query('[name="document_year"]', this.element)

        if (element == selectDocumentYearEl) {
            this.isCompact = true

            this.showDocuments()
        }
    }

    showDocuments() {
        const selectDocumentYearEl = query('[name="document_year"]', this.element)
        const year = selectDocumentYearEl?.value

        let visibleCount = 0
        this.ref.items.forEach((item) => {
            if (((year && item.dataset.year <= year) && (!item.dataset.expyear || item.dataset.expyear > year)) || !year) {
                visibleCount += 1
                item.classList.remove('hidden')
            } else {
                item.classList.add('hidden')
            }

            if (this.isCompact && visibleCount > this.options.maxVisibleCount) {
                item.classList.add('hidden')
            }
        })

        const showMoreButtonEl = this.element.querySelector('[data-show-more-documents]')
        if (showMoreButtonEl) {
            if (visibleCount > this.options.maxVisibleCount && this.isCompact) {
                showMoreButtonEl.innerHTML = `${showMoreButtonEl.innerHTML.split('(')[0]} (${
                    visibleCount - this.options.maxVisibleCount
                })`
                showMoreButtonEl.classList.remove('hidden')
            } else {
                showMoreButtonEl.classList.add('hidden')
            }
        }
    }

    showMoreDocuments() {
        this.isCompact = false
        this.showDocuments()
    }
}
